import { useContext } from 'react';
import { PlaygroundState } from '@playground/context/state';
import { PlaygroundContext } from '@playground/context';
import { SetExerciseAction, SetRunnerAction } from '@playground/context/actions';

export const usePlayground = () => {
  const { state } = useContext(PlaygroundContext);
  return state;
};

export const usePlaygroundMutations = () => {
  const { dispatch } = useContext(PlaygroundContext);

  const setExercise = (exercise: PlaygroundState['exercise']) => {
    dispatch(new SetExerciseAction(exercise));
  };

  const setRunner = (runner: Partial<PlaygroundState['runner']>) => {
    dispatch(new SetRunnerAction(runner));
  };

  return {
    setExercise,
    setRunner,
  };
};
